export default "__VITE_ASSET__BgIpEAg$__"